export const LICENSE_REVOKE_REQUEST = 'LICENSE_REVOKE_REQUEST';
export const LICENSE_REVOKE_SUCCESS = 'LICENSE_REVOKE_SUCCESS';
export const LICENSE_REVOKE_FAILURE = 'LICENSE_REVOKE_FAILURE';
